export default __webpack_public_path__ + "static/media/icon_ETH_new.ec869469.svg";